import React from 'react';
import PropTypes from 'prop-types';
import { ExportButton } from '@common/components';
import { gql, useMutation } from '@common/hooks';
import { createMessage } from 'works/legacy/lib/message-helper';
import Filters from 'works/legacy/lib/filters';
import { useTeamExportButton } from 'works/components/export-team-button/export-team-button-context';

const GENERATE_CSV_EXPORT_WITH_EMAIL = gql`
  mutation createStaffingRequestAssignmentsExportEmail(
    $input: CreateStaffingRequestAssignmentsExportEmailInput!
  ) {
    createStaffingRequestAssignmentsExportEmail(input: $input) {
      success
    }
  }
`;

export function ExportAssignmentsButton({
  filterKey,
  requestTypes,
  assignmentStates,
}) {
  const { exportEnabled, disableExport } = useTeamExportButton();

  const onCompletedWithEmail = ({
    createStaffingRequestAssignmentsExportEmail: { success },
  }) => {
    if (success) {
      createMessage(
        'success',
        "The CSV Export is being generated. You'll receive an email when it's ready."
      );
      disableExport();
    } else {
      createMessage('error', 'CSV Export failed. Please try again.');
    }
  };

  const [performExportWithEmail, { loading: loadingWithEmail }] = useMutation(
    GENERATE_CSV_EXPORT_WITH_EMAIL,
    {
      onCompleted: onCompletedWithEmail,
      onError: () => {
        createMessage('error', 'CSV Export failed. Please try again.');
      },
    }
  );

  const onClickEmail = () => {
    performExportWithEmail({
      variables: {
        input: {
          filters: Filters.getFilters(filterKey),
          staffingRequestTypes: requestTypes,
          assignmentStates: assignmentStates,
        },
      },
    });
  };

  return (
    <>
      <ExportButton
        onClick={onClickEmail}
        loading={loadingWithEmail}
        disabled={!exportEnabled}
      >
        Export
      </ExportButton>
    </>
  );
}

ExportAssignmentsButton.propTypes = {
  filterKey: PropTypes.string.isRequired,
  requestTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  assignmentStates: PropTypes.arrayOf(PropTypes.string),
};
